if (customElements && !customElements.get('banner-parallax')) {
  class BannerParallax extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    initParallax() {
      if (typeof gsap === 'undefined') {
        console.error('Not found: GSAP');
        return;
      }

      const layersContainers = Array.from(this.querySelectorAll('[data-parallax-layers]'));
      if (!layersContainers.length) return;

      layersContainers.forEach((layersContainer) => {
        const images = Array.from(layersContainer.querySelectorAll('.banner-parallax__layer-img'));
        if (!images.length) return;

        const waitForImages = images.map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) {
                resolve();
              } else {
                img.addEventListener('load', resolve, { once: true });
                img.addEventListener('error', resolve, { once: true });
              }
            })
        );

        Promise.all(waitForImages).then(() => {
          this.setupGsap(layersContainer);
        });
      });
    }

    // CKC (Sept 2026): per-image depth strength. Custom layer files named
    // "ckc-parallax-strong-..." or "ckc-parallax-subtle-..." widen or narrow the
    // gap between layer speeds. The background (layer 1) speed never changes,
    // so nothing opens up at the edges. Any other image keeps the original speeds.
    getStrength(layersContainer) {
      const first = layersContainer.querySelector('[data-parallax-layer="1"]');
      const src = first ? first.currentSrc || first.src || '' : '';
      if (src.indexOf('ckc-parallax-strong') !== -1) return 1.6;
      if (src.indexOf('ckc-parallax-subtle') !== -1) return 0.5;
      return 1;
    }

    // CKC (Sept 2026): "orbit" scenes (layer files named "ckc-parallax-orbit-...").
    // The background (the star) stays still; the planet and the spacecraft drift
    // past it at different speeds for the whole time the banner is on screen.
    setupOrbit(layersContainer) {
      const isMobile = window.innerWidth < 750;
      const moves = isMobile ? [0, 5, 13] : [0, 9, 16];
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: layersContainer,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.4,
        },
      });
      moves.forEach((m, idx) => {
        const el = layersContainer.querySelector(`[data-parallax-layer="${idx + 1}"]`);
        if (!el || el.naturalWidth === 0 || m === 0) return;
        tl.fromTo(el, { yPercent: m }, { yPercent: -m, ease: 'none' }, 0);
      });
    }

    setupGsap(layersContainer) {
      const firstLayer = layersContainer.querySelector('[data-parallax-layer="1"]');
      const firstSrc = firstLayer ? firstLayer.currentSrc || firstLayer.src || '' : '';
      if (firstSrc.indexOf('ckc-parallax-orbit') !== -1) {
        this.setupOrbit(layersContainer);
        return;
      }
      const isMobile = window.innerWidth < 750;
      const baseSpeeds = isMobile ? [35, 27, 20, 10, 2] : [70, 55, 40, 20, 5];
      const strength = this.getStrength(layersContainer);
      const layerSpeeds = baseSpeeds.map((speed) =>
        Math.max(0, baseSpeeds[0] - (baseSpeeds[0] - speed) * strength)
      );

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: layersContainer,
          start: '0% 0%',
          end: '100% 0%',
          scrub: 0,
        },
      });

      layerSpeeds.forEach((yPercent, idx) => {
        const el = layersContainer.querySelector(`[data-parallax-layer="${idx + 1}"]`);
        if (!el) return;
        if (el.naturalWidth === 0) return;
        tl.fromTo(el, { yPercent: 0 }, { yPercent, ease: 'none' }, idx === 0 ? undefined : '<');
      });
    }

    init() {
      this.initParallax();
    }
  }

  customElements.define('banner-parallax', BannerParallax);
}

// On page load: if success overlay is visible, remove content-holder background to avoid double glass effect
document.querySelectorAll('[data-cf-success]').forEach(function (success) {
  if (!success.hidden) {
    var holder = success.closest('.banner-parallax__content-holder');
    if (holder) holder.classList.add('cf-success-active');
  }
});

document.addEventListener('click', function (e) {
  var backBtn = e.target.closest('[data-cf-back]');
  if (!backBtn) return;
  var success = backBtn.closest('[data-cf-success]');
  if (!success) return;

  // Restore content-holder glass background
  var holder = success.closest('.banner-parallax__content-holder');
  if (holder) holder.classList.remove('cf-success-active');

  // Hide success overlay
  success.hidden = true;

  // Clean URL: remove contact_posted param and hash
  var url = new URL(window.location.href);
  url.searchParams.delete('contact_posted');
  history.replaceState(null, '', url.pathname + url.search);
});

function updateCfSubmitState(body) {
  var inputs = Array.from(body.querySelectorAll('input, textarea'));
  var isValid = inputs.every(function (input) { return input.checkValidity(); });
  var submitBtn = body.querySelector('.banner-parallax__cf-submit');
  if (submitBtn) submitBtn.classList.toggle('is-valid', isValid);
}

document.addEventListener('input', function (e) {
  var body = e.target.closest('.banner-parallax__cf-body');
  if (body) updateCfSubmitState(body);
});

document.addEventListener('change', function (e) {
  var body = e.target.closest('.banner-parallax__cf-body');
  if (body) updateCfSubmitState(body);
});
